import { withInstall } from '@element-plus/utils/with-install'

import Link from './src/link.vue'

export const ElLink = withInstall(Link)
export default ElLink

export * from './src/link'
